import styled from '@emotion/styled'
import { Text } from 'components/Typography'

export const SListContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  flex-grow: 1;
`

export const SListText = styled(Text)`
  display: flex;

  & strong {
    color: var(--c-gray100);
  }
`
